import React, { useState, useEffect } from 'react';
import validator from 'validator';
import axios from 'axios';
import { defaultVariables } from '../../../../config/index';
import { connect } from "trim-redux";
import {Checkbox, FormControlLabel, InputAdornment, Typography, useMediaQuery} from "@mui/material";
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid2';
import LoadingButton from "../../../components/elements/LoadingButton";
import { Styles } from '../../../../config/design/styles';
import {useSnackbar} from "notistack";
import CssBaseline from "@mui/material/CssBaseline";
import AppCardLoaderFields from "../../../components/loaders/AppCardLoaderFields";
import {useNavigate} from "react-router-dom";
import FieldCounter from "../../../components/elements/fields/FieldCounter";
import SingleImageChooser from "../../fileManager/Components/SingleImageChooser";
import SubTitle from "../../../components/elements/SubTitle";
import {useParams} from "react-router";
import {isAdmin} from "../../../../config/Permissions";
import {useTranslation} from "react-i18next";
import RayaField from "../../../components/elements/fields/RayaField";
import {currencySymbol} from "../../../../config/values";
import NumberField from "../../../components/elements/fields/NumberField";
import MultipleImageChooser from "../../fileManager/Components/MultipleImageChooser";
import ShopChooser from "./components/ShopChooser";
import MenuChooser from "../../manage/shops/menus/MenuChooser";
import {theme} from "../../../../config/design/theme";
import MultipleFileChooser from "../../fileManager/Components/MultipleFileChooser";


const MakeShop = (props) => {
    const { classes } = props;
    const navigation = useNavigate();
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    let { id } = useParams();

    const [fields, setFields] = useState({
        name: '',
        price: '',
        discount_percent: '',
        base_inventory: '',
        inventory: '',
        description: '',
        purchase_cooldown_days: '',
    });
    const [thumbnail, setThumbnail] = useState(null);
    const [noInventory, setNoInventory] = useState(false);
    const [hasDailyInventory, setHasDailyInventory] = useState(true);
    const [menus, setMenus] = useState([]);
    const [gallery, setGallery] = useState([]);
    const [shop_id, setShopId] = useState(null);
    const [shop, setShop] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const loadData = async () =>{
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/products/get/${id}`,config)
            .then(response => {
                setFields({
                    name: response.data.name,
                    description: !!response.data.description ? response.data.description : '',
                    price: !!response.data.price ? response.data.price : '',
                    discount_percent: !!response.data.discount_percent ? response.data.discount_percent : '',
                    base_inventory: !!response.data.base_inventory ? response.data.base_inventory : '',
                    inventory: !!response.data.inventory ? response.data.inventory : '',
                    purchase_cooldown_days: !!response.data.purchase_cooldown_days ? response.data.purchase_cooldown_days : '',
                });
                setNoInventory(!response.data.has_inventory)
                setHasDailyInventory(response.data.has_daily_inventory)
                setThumbnail(response.data.thumbnail)
                setGallery(response.data.gallery)
                setMenus(!!response.data.menus ? response.data.menus : [])
                setShopId(response.data.shop_id)
                setShop(response.data.shop)
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false); // Set loading to false even if there is an error
            });
    }
    useEffect(() => {
        if(!!id){
            // Fetch match data when component mounts
            loadData();
            setEditMode(true);
        }else{
            if(!isAdmin()){
                if(!!props.user?.shop) {
                    setShopId(props.user?.shop?.id)
                }
            }

            setLoading(false);

        }
    }, [id]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    const handleInputChange = (fieldName, value) => {
        setFields((prevFields) => ({
            ...prevFields,
            [fieldName]: value,
        }));
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: '' }));
    };
    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};

        // Validation for full_name
        if (validator.isEmpty(fields.name)) {
            formIsValid = false;
            newErrors.name = t('emptyField');
        }
        if(!fields.price){
            formIsValid = false;
            newErrors.price = t('emptyField');
        }
        if(!shop_id){
            formIsValid = false;
            newErrors.shop_id = t('emptyField');
        }
        if(!noInventory){
            if(!!hasDailyInventory){
                if(!fields.base_inventory){
                    formIsValid = false;
                    newErrors.base_inventory = t('emptyField');
                }
            }else{
                if(!fields.inventory){
                    formIsValid = false;
                    newErrors.inventory = t('emptyField');
                }
            }
        }
        if(menus.length === 0){
            formIsValid = false;
            newErrors.menus = t('chooseAMenu');
        }
        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };

    const handleRequest = async () => {

        const data = new FormData();
        data.append('name', fields.name);
        data.append('description', fields.description);
        data.append('price', fields.price);
        data.append('discount_percent', fields.discount_percent);
        data.append('base_inventory', fields.base_inventory);
        data.append('inventory', fields.inventory);
        if (!!isAdmin()) {
            data.append('purchase_cooldown_days', fields.purchase_cooldown_days || 0);
        }
        data.append('has_inventory', !noInventory ? 1 : 0);
        data.append('has_daily_inventory', !!hasDailyInventory ? 1 : 0);
        data.append('file_id', !!thumbnail ? thumbnail.id : '');
        if(!!id){
            data.append('item_id', id);
        }
        if(!!shop_id){
            data.append('shop_id', shop_id);
        }
        if(!!menus){
            data.append('menus', JSON.stringify(menus));
        }
        if(!!gallery){
            data.append('gallery', JSON.stringify(gallery));
        }
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            await axios.post(`${defaultVariables.url}/products/make`, data, config);
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });
            setSubmitLoading(false);
            handleGoBack();

        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            if(error.response.status === 403){
                enqueueSnackbar(t('duplicateProductName'), { variant: 'warning' });
            }else{
                enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });

            }
        }
    };
    const handleGoBack = () => {
        if(!!isAdmin()){
            navigation(`/panel/manage/products/view-all`);
        }else{
            navigation(`/panel/vendor/products/view-all`);
        }
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };
    const handleShop = (shop) => {
        if(!!shop){
            setShopId(shop.id)
            setErrors((prevErrors) => ({ ...prevErrors, shop_id: '' }));
        }
    }
    if (loading) {
        return <AppCardLoaderFields />;
    }

    return (
        <Grid container spacing={2} justify="center" >
            <CssBaseline />
            {
                (!!editMode && !!isAdmin()) &&
                <Grid item size={12} className="manage-org-sec">
                    <Typography>{t('shop')}: <strong>{shop.name}</strong></Typography>
                </Grid>
            }
            <Grid item size={12}>
                <Grid container spacing={2}  >
                    <Grid item size={{xs:12,md:3}}>
                        <Grid container spacing={2}>
                            <Grid item size={12} style={{display:"flex",flexDirection:'column',alignItems:'center'}}>
                                <SingleImageChooser
                                    primary
                                    onChange={(thumbnail) => setThumbnail(thumbnail)}
                                    initial={thumbnail}
                                    width={isMobile ? 150 : ''}
                                />
                            </Grid>
                            <Grid item size={12}>
                                <div style={{padding:10,backgroundColor:"#f9f9f9",borderRadius:12,height:"100%"}}>
                                    <SubTitle align="left">{t('productGallery')}</SubTitle>
                                    <MultipleFileChooser
                                        onChange={(gallery) => setGallery(gallery)}
                                        initial={gallery}
                                    />
                                </div>
                            </Grid>
                        </Grid>

                    </Grid>
                    <Grid item size={{xs:12,md:9}}>
                        <Grid container spacing={2}>
                            <Grid item size={{xs:12}}>
                                <RayaField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    label={t('productName')}
                                    name="name"
                                    value={fields.name}
                                    onChange={handleChange}
                                    error={!!errors.name}
                                    helperText={errors.name}
                                />
                            </Grid>
                            <Grid item size={{xs:12,md:6}}>
                                <NumberField
                                    fullWidth
                                    label={t('price')}
                                    variant="outlined"
                                    value={fields.price}
                                    endAdornment={currencySymbol}
                                    decimals={2}
                                    min={0}
                                    onChange={(res) => handleInputChange('price', res)}
                                    error={!!errors.price}
                                    helperText={errors.price}
                                />
                            </Grid>
                            <Grid item size={{xs:12,md:6}}>
                                <NumberField
                                    fullWidth
                                    label={t('discount_percent')}
                                    variant="outlined"
                                    value={fields.discount_percent}
                                    endAdornment={"%"}
                                    decimals={0}
                                    min={0}
                                    max={99}
                                    onChange={(res) => handleInputChange('discount_percent',res)}
                                />
                            </Grid>
                            <Grid item size={12}>
                                <RayaField
                                    variant="outlined"
                                    multiline
                                    fullWidth
                                    name="description"
                                    label={t('productDesc')}
                                    placeholder={t('productDescInfo')}
                                    type="text"
                                    id="description"
                                    className={classes.inputCtl}
                                    rows="4"
                                    value={fields.description}
                                    onChange={handleChange}
                                    error = {!!errors['description']}
                                    helperText={errors['description']}
                                    slotProps={{
                                        input:{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <FieldCounter length={fields.description.length} max={1000}/>
                                                </InputAdornment>
                                            ),
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item size={{xs:12,md:6}}>
                                <Grid container spacing={2}>
                                    <Grid item size={{ xs: 12 }}>
                                        <FormControlLabel
                                            label={t('unlimitedInventory')}
                                            control={<Checkbox  color="secondary" checked={noInventory} onChange={() => setNoInventory(!noInventory)} />}
                                        />
                                        {
                                            !noInventory &&
                                            <FormControlLabel
                                                label={t('hasDailyInventory')}
                                                control={<Checkbox  color="secondary" checked={hasDailyInventory} onChange={() => setHasDailyInventory(!hasDailyInventory)} />}
                                            />
                                        }
                                    </Grid>
                                    {
                                        !noInventory &&
                                        <>

                                            {
                                                !!hasDailyInventory ?
                                                    <>
                                                        <Grid item size={{xs:12}}>
                                                            <NumberField
                                                                fullWidth
                                                                label={t('base_inventory')}
                                                                variant="outlined"
                                                                optional
                                                                min={0}
                                                                decimals={0}
                                                                value={fields.base_inventory}
                                                                onChange={(res) => handleInputChange('base_inventory', res)}
                                                                error={!!errors.base_inventory}
                                                                helperText={!!errors.base_inventory ? errors.base_inventory : t('baseInventoryDesc')}
                                                            />
                                                        </Grid>
                                                    </>
                                                    :
                                                    <>
                                                        <Grid item size={{xs:12}}>
                                                            <NumberField
                                                                fullWidth
                                                                label={t('inventory')}
                                                                variant="outlined"
                                                                optional
                                                                min={0}
                                                                decimals={0}
                                                                value={fields.inventory}
                                                                onChange={(res) => handleInputChange('inventory', res)}
                                                                error={!!errors.inventory}
                                                                helperText={errors.inventory}
                                                            />
                                                        </Grid>
                                                    </>
                                            }

                                        </>
                                    }
                                    {
                                        !!isAdmin() &&
                                        <Grid item size={{xs:12}}>
                                            <NumberField
                                                fullWidth
                                                label={t('purchaseCooldownDays')}
                                                variant="outlined"
                                                optional
                                                min={0}
                                                decimals={0}
                                                value={fields.purchase_cooldown_days}
                                                onChange={(res) => handleInputChange('purchase_cooldown_days', res)}
                                                helperText={t('purchaseCooldownDaysDesc')}
                                            />
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                            {
                                (!!isAdmin() && !id) &&
                                <Grid item size={{xs:12}}>
                                    <ShopChooser
                                        handleRes={(shop) => handleShop(shop)}
                                        default_id={shop_id}
                                        error={errors['shop_id']}
                                    />
                                </Grid>
                            }
                            {
                                !!shop_id &&
                                <Grid item size={{xs:12}}>
                                    <div style={{padding:20,backgroundColor:"#f9f9f9",borderRadius:12,height:"100%"}}>
                                        <SubTitle align="left">{t('productMenu')}</SubTitle>
                                        <MenuChooser
                                            onCheckedChange={(menus) => setMenus(menus)}
                                            shop_id={shop_id}
                                            checkedMenus={menus}
                                        />
                                        {
                                            !!errors['menus'] &&
                                            <Typography className='error-text'>{errors['menus']}</Typography>
                                        }
                                    </div>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>




            <Grid item size={12}>
                <LoadingButton
                    variant="contained"
                    color="secondary"
                    onClick={handleSubmit}
                    loading={submitLoading}
                >
                    {t('setDetails')}
                </LoadingButton>
            </Grid>

        </Grid>
    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user
});

export default withStyles(Styles)(connect(mstp)(MakeShop));
